export default "__VITE_ASSET__DbgLGiTi__"